/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import { CustomTheme } from '@masfront/common-b2c'

import { Box, Link, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: CustomTheme) => ({
  fieldsApart: {
    justifyContent: 'space-between',
    display: 'flex',
  },
  textRow: {
    alignItems: 'center',
    display: 'flex',
  },
  primaryText: {
    marginRight: theme.spacing(2),
  },
  marginLeft12: {
    marginLeft: theme.spacing(3),
  },
  paddingRight12: {
    paddingRight: theme.spacing(3),
  },
  subPrimaryText: {
    fontWeight: 'normal',
  },
  secondaryText: {
    marginRight: 0,
    wordBreak: 'break-word',
  },
}))

interface Link {
  label: string
  action: () => void
  disabled?: boolean
  dataHook?: string
}

interface LineItemProps {
  className?: string
  dataHook?: string
  primaryText: string
  subPrimaryText?: string
  secondaryText?: string | Link
  link?: Link
  fieldsApart?: boolean
  isHeader?: boolean
  vertical?: boolean
}

function isLink(text: string | number | Link): text is Link {
  return !!(text as Link).label
}

const LineItem: React.FC<LineItemProps> = ({
  className,
  dataHook,
  primaryText,
  subPrimaryText,
  secondaryText,
  link,
  fieldsApart,
  isHeader,
  vertical,
}) => {
  const styles = useStyles()

  return (
    <Box justifyContent="space-between" className={className} data-hook={dataHook}>
      <Box className={`${!vertical && styles.textRow} ${fieldsApart && styles.fieldsApart}`}>
        <Typography className={`primary-text ${styles.primaryText}`} variant="body2">
          {primaryText || ''}
          {isHeader ? '' : ':'}
        </Typography>
        {subPrimaryText && (
          <Typography className={`sub-primary-text ${styles.subPrimaryText}`} variant="caption">
            {subPrimaryText}
          </Typography>
        )}
        {secondaryText &&
          (isLink(secondaryText) ? (
            <Link
              component="button"
              className={`secondary-text ${styles.paddingRight12}`}
              disabled={secondaryText.disabled}
              onClick={secondaryText.action}
            >
              <Typography className="link" variant="body1">
                {secondaryText.label}
              </Typography>
            </Link>
          ) : (
            <Typography
              className={`secondary-text ${styles.secondaryText} ${link && styles.paddingRight12}`}
              variant="subtitle1"
            >
              {secondaryText}
            </Typography>
          ))}
        {link && (
          <Link
            component="button"
            disabled={link.disabled}
            onClick={link.action}
            data-hook={link.dataHook}
          >
            <Typography className="link" variant="body1">
              {link.label}
            </Typography>
          </Link>
        )}
      </Box>
    </Box>
  )
}

LineItem.defaultProps = {
  fieldsApart: false,
  isHeader: false,
  vertical: false,
}

export default LineItem
